import React, { useEffect, useState } from 'react';
import api from '../services/api';
import API_URL from '../config';
import './UsersList.css';

const UsersList = () => {
  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await api.get(`${API_URL}/api/users/admin/users`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        // Trier les utilisateurs en mettant les clients en premier
        const sortedUsers = response.data.sort((a, b) => {
          return a.role === 'client' ? -1 : 1;
        });

        setUsers(sortedUsers);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching users:', error);
        setMessage('Erreur lors de la récupération des utilisateurs.');
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  return (
    <div className="users-list-container">
      <h2>Liste des Utilisateurs</h2>
      {loading ? (
        <p>Veuillez patienter, chargement des utilisateurs...</p>
      ) : message ? (
        <p>{message}</p>
      ) : (
        <ul className="users-list">
          {users.length > 0 ? (
            users.map((user) => (
              <li key={user._id} className="user-item">
                <p><strong>Nom:</strong> {user.name}</p>
                <p><strong>Prénom:</strong> {user.Firstname}</p>
                <p><strong>Email:</strong> {user.email}</p>
                {user.address && (
                  <p><strong>Adresse:</strong> {`${user.address}, ${user.postalCode} ${user.city}`}</p>
                )}
                {user.mobileNumber && <p><strong>Numéro de mobile:</strong> {user.mobileNumber}</p>}
                <p><strong>Rôle:</strong> {user.role === 'admin' ? 'Administrateur' : 'Client'}</p>
              </li>
            ))
          ) : (
            <p>Aucun utilisateur trouvé.</p>
          )}
        </ul>
      )}
    </div>
  );
};

export default UsersList;